// extracted by css-extract-rspack-plugin
export default {"Header":"dtS7J","HeaderButton":"qU8Io"};